import { Spinner } from '@atoms/Spinner';
import { UploadSimple, WarningCircle } from '@phosphor-icons/react';

export type DropzoneProps = {
  onClick: () => void;
  label?: string;
  icon?: string;
  loading?: boolean;
  disabled?: boolean;
};

interface DropzoneBodyProps {
  label?: string;
  icon?: string;
  disabled?: boolean;
}

const DropzoneBody: React.FC<DropzoneBodyProps> = ({
  label,
  icon,
  disabled,
}) => {
  const defaultLabel = disabled ? 'Max photo limit reached' : 'Upload photo';
  const defaultIcon = disabled ? (
    <WarningCircle aria-label="Close icon" />
  ) : (
    <UploadSimple aria-label="Upload icon" />
  );
  return (
    <span
      className={`flex flex-col items-center gap-2 [&_svg]:h-8 [&_svg]:w-8 ${disabled ? '[&_svg]:fill-text-body' : '[&_svg]:fill-action-button'}`}
    >
      <span data-testid="dropzone-icon">{icon ?? defaultIcon}</span>
      <p
        className={`${disabled ? 'text-text-body' : 'text-action-button'} text-bodyLg`}
      >
        {label ?? defaultLabel}
      </p>
    </span>
  );
};

export const Dropzone = ({
  onClick,
  label,
  icon,
  loading,
  disabled,
}: DropzoneProps) => {
  return (
    <button
      data-testid="dropzone"
      className={`max-w-form border-ui-border flex flex h-[12rem] w-full items-center justify-center gap-4 rounded-lg border-2 border-dashed md:h-[18rem] ${disabled ? 'cursor-not-allowed' : 'cursor-pointer'}`}
      onClick={onClick}
      disabled={disabled}
    >
      {loading ? (
        <Spinner />
      ) : (
        <DropzoneBody icon={icon} label={label} disabled={disabled} />
      )}
    </button>
  );
};

Dropzone.displayName = 'Dropzone';
